<template>
<div class="BasketPreview">
  <div class="wrapper col-12" :class="{'hidden': !item.is_visible}">
    <div class="checking">
      <v-checkbox
        :input-value="item.is_checked"
        :class="'ma-0 mt-3'"
        @change="toggleCheckedItem(item,item.is_checked)"
      ></v-checkbox>
    </div>
    <div class="title col-8">{{item.service_name}}</div>
    <div class="price col-4">
      <section class="d-flex flex-column align-end" v-if="item.is_visible">
        <div class="d-flex align-center gap-3 justify-end pb-2">
          <BasketCounter
            :id="item.service_card_id"
          />
<!--          <v-btn-->
<!--            :icon="true"-->
<!--            :depressed="true"-->
<!--            :disabled="!item.is_visible"-->
<!--            @click="changeAmount(item.id,item.quantity - 1)"-->
<!--          >-->
<!--            <span class="cursor-pointer d-flex">-->
<!--              <svg width="24" height="4" viewBox="0 0 24 4" fill="currentColor" xmlns="http://www.w3.org/2000/svg">-->
<!--                <rect width="24" height="3.5" fill="#25325F"/>-->
<!--              </svg>-->
<!--            </span>-->
<!--          </v-btn>-->
<!--          <v-text-field-->
<!--            outlined-->
<!--            dense-->
<!--            class=" count-input"-->
<!--            hide-details-->
<!--            :readonly="true"-->
<!--            :disabled="!item.is_visible"-->
<!--            :value="item.quantity"-->
<!--          />-->
<!--          <v-btn-->
<!--            :icon="true"-->
<!--            :depressed="true"-->
<!--            :disabled="!item.is_visible"-->
<!--            @click="changeAmount(item.id,item.quantity + 1)"-->
<!--          >-->
<!--            <span class="cursor-pointer d-flex">-->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M10.2857 13.7143H0V10.2857H10.2857V0H13.7143V10.2857H24V13.7143H13.7143V24H10.2857V13.7143Z" fill="#25325F"/>-->
<!--            </svg>-->
<!--          </span>-->
<!--          </v-btn>-->
        </div>
        <div class="price-per-item" v-if="Number(item.unit_price)">
          <span>{{item.unit_price}} ₽ / ед. </span>
        </div>
      </section>
      <section
        class="d-flex flex-column align-end justify-center"
        v-else
      >
        <div class="text-gray font-weight-medium ">
          Услуга недоступна

        </div>
      </section>
      <section class="action">
        <v-btn
          icon
          color="error"
          @click="removeServiceFromCart(item.id)"
        >
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>
      </section>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import BasketCounter from '@/components/basket/BasketCounter.vue';

/**
 * Компонент: BasketPreview
 * Описание:
 */
export default {
  name: 'BasketPreview',

  components: { BasketCounter },

  props: {
    item: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      addToBasket: 'basket/basket/addToBasket',
      fetchUserBasket: 'basket/basket/fetchUserBasket',
      removeFromCart: 'basket/basket/removeFromBasket',
      changeCount: 'basket/basket/changeCount',
      toggleChecked: 'basket/basket/toggleChecked',
    }),
    async addTocart(id) {
      const data = {
        service_card_id: id,
        quantity: 1
      };
      await this.addToBasket(data);
      await this.fetchUserBasket();
    },
    async removeServiceFromCart(id) {
      await this.removeFromCart(id);
      await this.fetchUserBasket();
    },
    async changeAmount(id, count) {
      const data = {
        id,
        quantity: count,
      };
      await this.changeCount(data);
      await this.fetchUserBasket();
    },
    async toggleCheckedItem(item, checked = false) {
      const data = {
        id: item.id,
        is_checked: !checked,
      };
      await this.toggleChecked(data);
      await this.fetchUserBasket();
    }
  },
};
</script>

<style scoped lang="scss">
.BasketPreview {
  /* Стили компонента */
  & .wrapper{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding-bottom: 8px;
    &.hidden{
      opacity: 0.6;
    }
    & .title{
      font-size: 16px;
      color: black;
    }
    & .price{
      width: fit-content;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;
      gap: 12px;
      & .count-input{
        max-width: 100px;
        text-align: center;
        & ::v-deep input{
          text-align: center;
        }
      }
      & .price-per-item{
        font-weight: 600;
        font-size: 16px;
      }
      & .action{
        .v-btn{
          padding: 12px;
          border: 1px solid var(--color-grey-500);
          border-radius: 50%;
          height: 40px;
          width: 40px;
          & .v-icon{
            font-size: 21px;
          }
        }
      }
    }

  }
}
</style>
